export default "/_next/static/images/ca547b4d0a6d4888e6cc4c0a915a8346.jpg";